import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET, POST } from "../../../services/api";
import { apiUrl } from "../../../ApiHelper/ApiUrl";

export const getProjects = createAsyncThunk(
    "project/getProjects",
    async (_, { rejectWithValue }) => {
        try {
            const orgId = process.env.REACT_APP_ORG_ID;
            const response = await GET(
                "project", 
                `${apiUrl.list_projects}/${orgId}`
            );

            return response?.data;
        } catch (error) {
            console.log("##error", error?.detail?.message || error?.message || "Something Went Wrong");
            return rejectWithValue(
                error?.detail?.message || error?.message || "Something Went Wrong"
            );
        }
    }
);

export const geProjectLists = createAsyncThunk(
    "project/geProjectLists",
    async (_, { rejectWithValue }) => {
        try {
            const result = await GET(
                "project",
                `${apiUrl?.list_of_project}`
            );

            if(result?.data?.status === true) {
                return result?.data || [];
            }

            // ❌ API returned error but no exception
            return rejectWithValue(
                result?.message || "Failed to fetch project list"
            );
            
        } catch (error) {
            console.log("##error", error?.detail?.message || error?.message || "Something Went Wrong");
            return rejectWithValue(
                error?.detail?.message || error?.message || "Something Went Wrong"
            );
        }
    }
);

export const createProject = createAsyncThunk(
  "project/createProject",
  async (payload) => {

    console.log('##payload1111', payload);
    try {
      const response = await POST(
        "project",
        `${apiUrl.create_project}`,
        payload
      );
      if (response?.status === 200 || response?.status === 201) {
        return response?.data;
      } else {
        throw new Error(response?.data?.message || "Failed to create project");
      }
    } catch (error) {
        console.log("##erorr", error)
      throw error;
    }
  }
);

const projectSlice = createSlice({
    name: "project",
    initialState: {
        data: [],
        loading: false,
        error: null,
        switched: null,

        selectedProject: localStorage.getItem("selectedProject") || null,
    },
    reducers: {
        switchProject: (state, action) => {
            state.switched = action.payload;
            console.log("##switched", action.payload);
            localStorage.setItem('languages', action?.payload?.language);
            localStorage.setItem('selectedProject', action?.payload?.projectId);
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getProjects.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getProjects.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload?.data;
            })
            .addCase(getProjects.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { switchProject } = projectSlice.actions;

export default projectSlice.reducer;